import React from 'react';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { useState, useEffect } from 'react';
//import SocketActions from './components/SocketActions';
import Login from './components/Login';
import MainForm from './components/MainForm';
import Campaigns from './components/Campaigns';
import AdminCampaigns from './components/AdminCampaigns';
import CampaignDetails from './components/CampaignDetails';
import Tasks from './components/Tasks';
import VariableFields from './components/VariableFields';
import NewCampaign from './components/NewCampaign';
import NewClaroVentasCampaign from './components/NewClaroVentasCampaign';
import Reports from './components/Reports';
import Payments from './components/Payments';
import SoftphonePanel from './components/SoftphonePanel';
import ClientsSearch from './components/ClientsSearch'; 
import ClaroVentasClientsSearch from './components/ClaroVentasClientsSearch'; 
import JunglabetClientsSearch from './components/JunglabetClientsSearch';
import ClaroDicomClientsSearch from './components/ClaroDicomClientsSearch';
import WaitingCalls from './components/WaitingCalls';
import Profile from './components/Profile';
import Monitor from './components/Monitor';
import Monitor2 from './components/Monitor2';
import HourlyReport from './components/HourlyReport';
import ChatReport from './components/ChatReport';
import ChatDashboard from './components/ChatDashboard';
import IvrDts from './components/IvrDts';
import CreateExecutives from './components/CreateExecutives';

import { SoftphoneProvider } from './components/SoftphoneContext';

import './App.css';

function App() {
  
  
  const [currentPhone, setCurrentPhone] = useState(0); //current phone
  const [selectedCampaign, setSelectedCampaign] = useState(null); //current selected campaign
  const [currentClient, setCurrentClient] = useState(null); //current Client

  const [inboundConnectedQueues, setInboundConnectedQueues] = useState([]);
  const [lastRecordingData, setLastRecordingData] = useState(null);
  
  useEffect(() => {
    document.title = `Athena CRM [v ${process.env.REACT_APP_VERSION_CODE}]`;
    document.documentElement.className = 'theme-light';
  }, []);

  return (
    <SoftphoneProvider>
      <div className="App">
        <Router> 
        <Switch>
          <Route exact path="/">
            <Login/>
          </Route>
          <Route exact path="/login">
              <Login />
          </Route>
          <Route exact path="/campaigns">
              <Campaigns inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues}/>
              <SoftphonePanel currentPhone={currentPhone} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>
          <Route exact path="/adminCampaigns">
              <AdminCampaigns />
          </Route>
          
          <Route exact path="/tasks">
              <Tasks inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues}/>
            <SoftphonePanel currentClient={currentClient} currentPhone={currentPhone} selectedCampaign={selectedCampaign}  inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>
          <Route exact path="/fields">
            <VariableFields />
          </Route>

          <Route exact path="/reports">
            <Reports />
          </Route>

          <Route exact path="/payments">
            <Payments />
          </Route>

          <Route exact path="/newCampaign">
            <NewCampaign />
          </Route>

          <Route exact path="/clients">
              <ClientsSearch inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues}/>
              <SoftphonePanel currentPhone={currentPhone} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>

          <Route exact path="/clients/:inboundQueue/:phone">
              <ClientsSearch inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues}/>
              <SoftphonePanel currentPhone={currentPhone} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>

          <Route exact path="/clientsClaroVentas/:phone">
              <ClaroVentasClientsSearch inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues}/>
              <SoftphonePanel currentPhone={currentPhone} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>

          <Route exact path="/clientsJunglabet/:phone">
              <JunglabetClientsSearch inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues}/>
              <SoftphonePanel currentPhone={currentPhone} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>

          <Route exact path="/clientsClaroDicom/:phone">
              <ClaroDicomClientsSearch inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues}/>
              <SoftphonePanel currentPhone={currentPhone} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>

            <Route exact path="/newClaroVentasCampaign">
              <NewClaroVentasCampaign  />
          </Route>

          <Route exact path="/waitingCalls/:campaignId">
              <WaitingCalls inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues}/>
              <SoftphonePanel currentPhone={currentPhone} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>

          <Route exact path="/campaign/:campaignId">
              <CampaignDetails inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues}/>
              <SoftphonePanel currentPhone={currentPhone} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>
          
          <Route exact path="/:campaignId/:clientId"> {/* CAMPAÑAS ASISTIDAS */}
              <MainForm setCurrentPhone={setCurrentPhone} setCurrentClient={setCurrentClient} setSelectedCampaign={setSelectedCampaign} inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues} lastRecordingData={lastRecordingData} setLastRecordingData={setLastRecordingData} />
              <SoftphonePanel currentClient={currentClient} currentPhone={currentPhone} selectedCampaign={selectedCampaign} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>

          <Route exact path="/:campaignId/:clientId/:phone">{/* CAMPAÑAS PROGRESIVAS (VIENE TELEFONO) */}
              <MainForm setCurrentPhone={setCurrentPhone} setCurrentClient={setCurrentClient} setSelectedCampaign={setSelectedCampaign} inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues} lastRecordingData={lastRecordingData} setLastRecordingData={setLastRecordingData} />
              <SoftphonePanel currentClient={currentClient} currentPhone={currentPhone} selectedCampaign={selectedCampaign} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>


          {/* CASOS CON STATUS 1/0 que vienen desde clientSeearch*/}
            <Route exact path="/search/:campaignId/:clientId/:clientStatus"> 
              <MainForm setCurrentPhone={setCurrentPhone} setCurrentClient={setCurrentClient} setSelectedCampaign={setSelectedCampaign} inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues} lastRecordingData={lastRecordingData} setLastRecordingData={setLastRecordingData} />
              <SoftphonePanel currentClient={currentClient} currentPhone={currentPhone} selectedCampaign={selectedCampaign} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>

          <Route exact path="/search/:campaignId/:clientId/:phone/:clientStatus">
              <MainForm setCurrentPhone={setCurrentPhone} setCurrentClient={setCurrentClient} setSelectedCampaign={setSelectedCampaign} inboundConnectedQueues={inboundConnectedQueues} setInboundConnectedQueues={setInboundConnectedQueues} lastRecordingData={lastRecordingData} setLastRecordingData={setLastRecordingData} />
              <SoftphonePanel currentClient={currentClient} currentPhone={currentPhone} selectedCampaign={selectedCampaign} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
          </Route>

            <Route exact path="/ivrDts">
              <IvrDts />
              <SoftphonePanel currentClient={currentClient} currentPhone={currentPhone} selectedCampaign={selectedCampaign} inboundConnectedQueues={inboundConnectedQueues} setLastRecordingData={setLastRecordingData}></SoftphonePanel>
            </Route>

            


          <Route exact path="/profile">
            <Profile setInboundConnectedQueues={setInboundConnectedQueues}/>
          </Route>
          
          <Route exact path="/hourlyReport">
              <HourlyReport/>
          </Route>

          <Route exact path="/createExecutives">
              <CreateExecutives/>
          </Route>

          <Route exact path="/chatReport">
              <ChatReport />
          </Route>

          <Route exact path="/chatDashboard">
              <ChatDashboard />
          </Route>


          <Route exact path="/monitor"> 
            <Monitor/>
          </Route>

          <Route exact path="/monitor2"> 
            <Monitor2/>
          </Route>
          
        </Switch>
        </Router>
      </div>
    </SoftphoneProvider>
  );
}

export default App;
